'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIList',

  propTypes: {
    childClassName: _react.PropTypes.string,
    className: _react.PropTypes.string,
    children: _react.PropTypes.node,
    inline: _react.PropTypes.bool.isRequired,
    ordered: _react.PropTypes.bool.isRequired,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(['default', 'inline-divided'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      inline: false,
      ordered: false,
      styled: false,
      childClassName: '',
      use: 'default'
    };
  },
  getClassName: function getClassName(_ref) {
    var inline = _ref.inline,
        styled = _ref.styled,
        className = _ref.className,
        use = _ref.use;

    return (0, _reactUtils.classNames)('uiList', {
      'private-list--inline': inline,
      'private-list--inline-divided': use === 'inline-divided',
      'private-list--unstyled': !styled
    }, className);
  },
  renderItems: function renderItems(_ref2) {
    var children = _ref2.children,
        childClassName = _ref2.childClassName;

    return _react.Children.map(children, function (child) {
      if (child == null) {
        return null;
      }

      var className = (0, _reactUtils.classNames)('uiListItem', 'private-list__item', childClassName);

      return _react2.default.createElement(
        'li',
        { className: className },
        child
      );
    });
  },
  renderOrdered: function renderOrdered(_ref3, _ref4) {
    var rest = _ref3.rest;
    var computedClassName = _ref4.computedClassName,
        renderedItems = _ref4.renderedItems;

    return _react2.default.createElement(
      'ol',
      _extends({}, rest, { className: computedClassName }),
      renderedItems
    );
  },
  renderUnordered: function renderUnordered(_ref5, _ref6) {
    var rest = _ref5.rest;
    var computedClassName = _ref6.computedClassName,
        renderedItems = _ref6.renderedItems;

    return _react2.default.createElement(
      'ul',
      _extends({}, rest, { className: computedClassName }),
      renderedItems
    );
  },
  render: function render() {
    var _props = this.props,
        ordered = _props.ordered,
        styled = _props.styled,
        inline = _props.inline,
        className = _props.className,
        children = _props.children,
        childClassName = _props.childClassName,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['ordered', 'styled', 'inline', 'className', 'children', 'childClassName', 'use']);

    var computedClassName = this.getClassName({
      inline: inline,
      styled: styled,
      className: className,
      use: use
    });
    var renderedItems = this.renderItems({ children: children, childClassName: childClassName });

    if (use === 'inline-divided' && !inline) {
      _devLogger2.default.warn({
        message: 'UIList: `inline` needs to be `true` when `use="inline-divided"` is set',
        key: 'UIList: use inline-divided requires inline'
      });
    }

    if (ordered) {
      return this.renderOrdered({ rest: rest }, { computedClassName: computedClassName, renderedItems: renderedItems });
    }
    return this.renderUnordered({ rest: rest }, { computedClassName: computedClassName, renderedItems: renderedItems });
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/list/UIList.js
// module id = 314
// module chunks = 0